import {
  useMissionControlSubscription,
  type MissionControlEventSubscription,
} from "@/context/MissionControlWebSocketContext";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";

export interface UseAgenticSubscriptionOptions {
  /** When false, handlers are not registered. Defaults to true. */
  enabled?: boolean;
  /** Gate on parent tab/view (e.g. Mission Control tasks tab). Defaults to true. */
  tabActive?: boolean;
}

/**
 * Mission Control WebSocket subscription gated by OS window lifecycle.
 * Inactive / background windows do not register handlers.
 */
export function useAgenticSubscription(
  subscription: MissionControlEventSubscription,
  options: UseAgenticSubscriptionOptions = {},
) {
  const isWindowLive = useWindowLive();
  const enabled =
    (options.enabled ?? true) &&
    (options.tabActive ?? true) &&
    isWindowLive;

  // useMissionControlSubscription registers a stable listener; handlers read latest sub via ref.
  const result = useMissionControlSubscription(subscription, { enabled });
  return { ...result, isWindowLive, enabled };
}
